import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { userApiService } from '../services/userApi';
import './ReferralCodeModal.css';

interface ReferralCodeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const ReferralCodeModal: React.FC<ReferralCodeModalProps> = ({
  isOpen,
  onClose,
  onSuccess
}) => {
  const { user } = useAuth();
  const [referrerPhone, setReferrerPhone] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!referrerPhone.trim()) {
      setError('Vui lòng nhập số điện thoại người mời');
      return;
    }

    // Validate phone format (basic validation)
    const phoneRegex = /^[0-9+\-\s()]+$/;
    if (!phoneRegex.test(referrerPhone)) {
      setError('Số điện thoại không hợp lệ');
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      const response = await userApiService.submitReferralCode(referrerPhone);

      if (response.success) {
        onSuccess();
        onClose();
        setReferrerPhone('');
      } else {
        setError(response.error || 'Có lỗi xảy ra khi nhập mã mời');
      }
    } catch (error) {
      setError('Có lỗi xảy ra. Vui lòng thử lại');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setReferrerPhone('');
    setError('');
    onClose();
  };

  return (
    <div className="referral-code-modal-overlay" onClick={handleClose}>
      <div className="referral-code-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="referral-code-modal-header">
          <h2>Nhập mã mời</h2>
          <button className="close-button" onClick={handleClose}>
            ×
          </button>
        </div>

        <div className="referral-code-modal-body">
          <p className="modal-description">
            Nhập số điện thoại của người đã mời bạn tham gia để nhận thưởng đặc biệt!
          </p>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="referrerPhone">Số điện thoại người mời</label>
              {error && <div className="error-message">{error}</div>}
              <input
                type="tel"
                id="referrerPhone"
                value={referrerPhone}
                onChange={(e) => setReferrerPhone(e.target.value)}
                placeholder="Nhập số điện thoại..."
                className={error ? 'error' : ''}
                disabled={isSubmitting}
              />
            </div>

            <div className="modal-actions">
              <button
                type="button"
                className="btn btn-cancel"
                onClick={handleClose}
                disabled={isSubmitting}
              >
                Hủy
              </button>
              <button
                type="submit"
                className="btn btn-submit"
                disabled={isSubmitting || !referrerPhone.trim()}
              >
                {isSubmitting ? 'Đang xử lý...' : 'Xác nhận'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ReferralCodeModal;
